import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import { RecoveryActions } from "./redux/actions/RecoveryActions";
import Input from "./components/Input";
import { validateEmail, parseQuery } from "./utils/helperFunctions";
import "./Palauta.css";

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  recoveryChangePassword: (email, password, token) =>
    dispatch(RecoveryActions.recoveryChangePassword(email, password, token)),
  checkRecoveryToken: (user, token) =>
    dispatch(RecoveryActions.checkRecoveryToken(user, token)),
});

// Convert to function component to use hooks
function Palauta(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = React.useState({
    email: "",
    password: "",
    password2: "",
    token: "",
    error: "",
  });


  React.useEffect(() => {
    // Set page title
    document.title = "Salasanan palautus - mitattu.fi";
    // Remove previous meta description if exists
    const oldMeta = document.querySelector('meta[name="description"]');
    if (oldMeta) document.head.removeChild(oldMeta);
    // Add new meta description
    const meta = document.createElement("meta");
    meta.name = "description";
    meta.content = "Salasanan palautus unohtuneen tilalle";
    document.head.appendChild(meta);
  }, []);

  React.useEffect(() => {
    const query = parseQuery(location.search);
    if (validateEmail(query.user)) {
      setState((prev) => ({
        ...prev,
        email: query.user,
        token: query.token,
      }));
      if (query.token) {
        props.checkRecoveryToken(query.user, query.token);
      } else {
        setState((prev) => ({
          ...prev,
          error:
            "Salasanan palautuslinkki ei ole kopioitunut kunnolla. Yritä kopioida linkki kokonaan. Jos ongelma jatkuu, ota yhteyttä sähköpostilla.",
        }));
      }
    } else {
      setState((prev) => ({
        ...prev,
        error:
          "Salasanan palautuslinkki ei ole kopioitunut kunnolla. Yritä kopioida linkki kokonaan. Jos ongelma jatkuu, ota yhteyttä sähköpostilla.",
        token: false,
        email: "",
      }));
    }
    // eslint-disable-next-line
  }, [location.search]);

  React.useEffect(() => {
    if (props.recoveryState.changeSuccess === true) {
      navigate("/");
    }
  }, [props.recoveryState.changeSuccess, navigate]);

  const onChangeEvent = (evt) => {
    setState((prev) => ({
      ...prev,
      [evt.target.name]: evt.target.value,
      error: "",
    }));
  };

  const resetPassword = async () => {
    if (state.password !== state.password2) {
      setState((prev) => ({
        ...prev,
        error: "Antamasi salasanat eivät täsmää.",
      }));
      return;
    }
    if (!state.password || state.password.length < 4) {
      setState((prev) => ({
        ...prev,
        error: "Anna kelvollinen salasana.",
      }));
      return;
    }
    if (!validateEmail(state.email)) {
      setState((prev) => ({
        ...prev,
        error: "Tarkista antamasi sähköpostiosoite",
      }));
      return;
    }
    props.recoveryChangePassword(state.email, state.password, state.token);
  };

  return (
    <>
      <div className="palauta-page">
        <h1>Palauta unohtunut salasana</h1>
        <div className="restore-form">
          Anna uusi salasana
          <Input
            label="Sähköposti"
            id="email"
            type="email"
            disabled={true}
            readOnly={true}
            value={state.email}
          />
          <Input
            type="password"
            name="password"
            label="Uusi salasana"
            onChange={onChangeEvent}
          />
          <Input
            type="password"
            name="password2"
            label="Uusi salasana uudelleen"
            onChange={onChangeEvent}
          />
          <p style={{ color: "red" }}>{state.error}</p>
          <p style={{ color: "red" }}>
            {props.recoveryState.tokenStatus === "error"
              ? "Virhe verkkoyhteydessä tai muu järjestelmävirhe. Yritä myöhemmin uudelleen."
              : null}
          </p>
          <p style={{ color: "red" }}>
            {props.recoveryState.tokenStatus === "invalid"
              ? "Käyttämäsi linkki on virheellinen tai vanhentunut. Tarkista, että kopioit koko linkin."
              : null}
          </p>
          <p style={{ color: "red" }}>
            {props.recoveryState.message
              ? props.recoveryState.message
              : null}
          </p>
          <input
            type="submit"
            onClick={resetPassword}
            className="button"
            disabled={
              !validateEmail(state.email) ||
              props.recoveryState.tokenStatus === "invalid"
            }
            value="Vaihda salasana"
          />
          <Link to="/">Peruuta</Link>
        </div>
      </div>
    </>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Palauta);
